import request from "@/utils/request";
import Qs from "qs";

// 图片上传Oss（可多文件上传）
export function ossUpload(data) {
  return request({
    url: "/common/admin_oss_upload",
    method: "post",
    // ContentType:'multipart/form-data',
    data: Qs.stringify(data),
  });
}

// 问卷主题列表
export function surveyList(data) {
  return request({
    url: "/survey/survey_list",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 问卷主题添加
export function surveyAdd(data) {
  return request({
    url: "/survey/survey_add",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 问卷主题编辑
export function surveyEdit(data) {
  return request({
    url: "/survey/survey_edit",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 问卷主题删除
export function surveyDel(data) {
  return request({
    url: "/survey/survey_del",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 问卷主题详情
export function surveyInfo(data) {
  return request({
    url: "/survey/survey_info",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 问卷参与人员
export function answerUsers(data) {
  return request({
    url: "/survey/survey_answer_users",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 问卷答题情况
export function surveyAnswers(data) {
  return request({
    url: "/survey/survey_answers",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 问卷添加
export function survey_complete_add(data) {
  return request({
    url: "/survey/survey_complete_add",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 查看问卷参与人员
export function survey_answer_users(data) {
  return request({
    url: "/survey/survey_answer_users",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 查看个人答卷
export function survey_answers(data) {
  return request({
    url: "/survey/survey_answers",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 问卷统计
export function survey_statistics(data) {
  return request({
    url: "/survey/survey_statistics",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 问卷统计导出
export function survey_statistics_export(data) {
  return request({
    url: "/survey/survey_statistics_export",
    method: "post",
    data: Qs.stringify(data),
    responseType: "blob",
  });
}

// 问卷导入模板
export function survey_info_template(data) {
  return request({
    url: "/survey/survey_info_template",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 问题导入模板
export function survey_question_template(data) {
  return request({
    url: "/survey/survey_question_template",
    method: "post",
    data: Qs.stringify(data),
  });
}
